import { render, staticRenderFns } from "./ViewDocument.vue?vue&type=template&id=788c5dac&"
import script from "./ViewDocument.vue?vue&type=script&lang=js&"
export * from "./ViewDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('788c5dac')) {
      api.createRecord('788c5dac', component.options)
    } else {
      api.reload('788c5dac', component.options)
    }
    module.hot.accept("./ViewDocument.vue?vue&type=template&id=788c5dac&", function () {
      api.rerender('788c5dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/production/jobcard/jobcard-view/ViewDocument.vue"
export default component.exports